import "./online-application.css";

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(".section-form");
  const urlParams = new URLSearchParams(window.location.search);

  if (form && urlParams.has("MultiFormSessionID")) {
    document.querySelector(".site-header").classList.add("is-stuck");

    const siteHeaderHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"),
    );
    const offset = form.getBoundingClientRect().top - siteHeaderHeight - 24;

    requestAnimationFrame(() => {
      window.scrollTo(0, offset + window.scrollY);
    });
  }
});
